export const ACTION_PREFIX = 'ACCOUNT_TO_LINK_SELECTION';
export const PARTITION = 'accountToLinkSelection';

export const actionTypes = {
  CONFIRM_LINK_PENDING: 'CONFIRM_LINK_PENDING',
  CONFIRM_LINK_FULFILLED: 'CONFIRM_LINK_FULFILLED',
  CONFIRM_LINK_REJECTED: 'CONFIRM_LINK_REJECTED',
  GET_ACCOUNTS_TO_LINK_PENDING: 'GET_ACCOUNTS_TO_LINK_PENDING',
  GET_ACCOUNTS_TO_LINK_FULFILLED: 'GET_ACCOUNTS_TO_LINK_FULFILLED',
  GET_ACCOUNTS_TO_LINK_REJECTED: 'GET_ACCOUNTS_TO_LINK_REJECTED',
  SET_SELECTED_ACCOUNT: 'SET_SELECTED_ACCOUNT',
};
